import { render, staticRenderFns } from "./InterestRateScenarioAndPVARate.vue?vue&type=template&id=4d2f5c72&scoped=true&"
import script from "./InterestRateScenarioAndPVARate.vue?vue&type=script&lang=js&"
export * from "./InterestRateScenarioAndPVARate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f5c72",
  null
  
)

export default component.exports